import React, { ReactNode } from "react";

import classNames from "classnames";
import { FormattedMessage } from "gatsby-plugin-react-intl";

import { PaymentProvider } from "./donationBoxDefault";
import PaymentMethods from "./paymentMethods";
import KontentAssetsImage from "../../templates/kontentAssetsImage";

import "./donationBox.scss";

export interface DonationBoxEyecatcherProps {
  className?: string;
  button: ReactNode;
  paymentProvider?: PaymentProvider[];
}

const DonationBoxEyecatcher: React.FC<DonationBoxEyecatcherProps> = ({
  className = undefined,
  button,
  paymentProvider = undefined,
}) => (
  <div className={classNames("donation-box", className)}>
    {paymentProvider && (
      <div className="mb-24">
        <div className="donation-box__payment-methods">
          <FormattedMessage id="payment.available_payment_methods" />
        </div>
        <PaymentMethods>
          {paymentProvider.map((item) => (
            <KontentAssetsImage
              height={36}
              fit="clip"
              key={item.name}
              data={item}
            />
          ))}
        </PaymentMethods>
      </div>
    )}
    {button}
  </div>
);

export default DonationBoxEyecatcher;
